import { FC, ReactNode } from 'react';
import styled from './index.module.scss';

interface IProps {
    icon?: ReactNode;
    title?: string;
    desc?: string;
    showUseCode?: boolean;
}

const ProductHeader: FC<IProps> = ({ icon, title, desc, showUseCode }) => {
    return (
        <div className={`${styled.ProductHeader}`}>
            {icon && icon}
            {title && <h6 className="product_title">{title}</h6>}
            {desc && <p className="product_desc">{desc}</p>}
            {showUseCode && <div className="product_code">Use Code: MEMBER04</div>}
        </div>
    );
};

export default ProductHeader;
